var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTerminal = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  d: "M8.8 2.75h6.4c1.324 0 2.264 0 2.995.07.72.069 1.16.198 1.503.409.438.268.805.635 1.073 1.073.21.343.34.783.409 1.503.07.73.07 1.671.07 2.995v6.4c0 1.324 0 2.264-.07 2.995-.069.72-.198 1.16-.409 1.503a3.25 3.25 0 0 1-1.073 1.073c-.343.21-.783.34-1.503.409-.73.07-1.671.07-2.995.07H8.8c-1.324 0-2.264 0-2.995-.07-.72-.069-1.16-.198-1.503-.409a3.25 3.25 0 0 1-1.073-1.073c-.21-.343-.34-.783-.409-1.503-.07-.73-.07-1.671-.07-2.995V8.8c0-1.324 0-2.264.07-2.995.069-.72.198-1.16.409-1.503a3.25 3.25 0 0 1 1.073-1.073c.343-.21.783-.34 1.503-.409.73-.07 1.671-.07 2.995-.07Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  d: "M7 9.5 9.5 12 7 14.5M12 12h5"
})));
export default SvgTerminal;